import { render, staticRenderFns } from "./ProjectItemForm.vue?vue&type=template&id=63e8fe53&"
import script from "./ProjectItemForm.vue?vue&type=script&lang=js&"
export * from "./ProjectItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports